import { useEffect, useState } from "react";
import "./SearchedContactResult.css";
import SelectedContactTable from "./SelectedContactTable";
import NurtureCampaignContactSearch from "./NurtureCampaignContactSearch";
import AddOrUploadContactForm from "./AddOrUploadContactForm";
import GenericTable from "../../../../genericComponents/genericTableComp/GenericTable";
import NoDataComp from "../../../../genericComponents/uiElements/NoDataComp";

// const PAGE_SIZE = 5;

export default function SearchedContactResult({
  searchedContacts = [],
  selectedContacts = [],
  setSelectedContacts = () => {},
  spotContactsDataIDS = [],
  handleSearchForContacts,
  searchHist,
  totalEntires,
  activeTab,
  setActiveTab,
  skipSearch = false,
  user,
  account,
  disableForward,
  setDisableForward =() => {},
  campaignId
}) {
  const [currentPage, setCurrentPage] = useState(1);

  const [selectUploadedContacts, setSelectUploadedContacts] = useState([]);
  const [manuallyAddedContacts, setManuallyAddedContacts] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [tabData, setTabData] = useState([]);
  const getId = (c) => c?.id || c?._id || c?.email || c?.linkedin_url;

  const handleAddContact = async (contact) => {
    // de-dupe against currently selected
    const exists = selectedContacts.some((c) => getId(c) === getId(contact));
    if (!exists) {
      setSelectedContacts((prev) => [...prev, contact]);
    }
    // after adding, switch to SELECTED tab
    setActiveTab("SELECTED");
  };
  useEffect(() => {
    if (
      (selectUploadedContacts && selectUploadedContacts.length > 0) ||
      (manuallyAddedContacts && manuallyAddedContacts?.length > 0)
    ) {
      setSelectedContacts((prev) => {
        // Combine existing contacts + uploaded ones, but skip duplicates
        const merged = [...prev];

        selectUploadedContacts.forEach((uploaded) => {
          const exists = merged.some(
            (item) => item._id === uploaded.id || item.id === uploaded.id
          );
          if (!exists) {
            merged.push(uploaded);
          }
        });

        manuallyAddedContacts.forEach((uploaded) => {
          const exists = merged.some(
            (item) => item._id === uploaded.id || item.id === uploaded.id
          );
          if (!exists) {
            merged.push(uploaded);
          }
        });

        return merged;
      });
    }
  }, [selectUploadedContacts, manuallyAddedContacts]);

  const tableColumns = [
    { id: "generic-check-box", width: "1rem" },

    {
      id: "contactName",
      label: "Name",
      width: 100,
      clickAction: true,
      alignment: "flex-start",
    },
    { id: "title", label: "Title", width: 150, alignment: "flex-start" },
    { id: "country", label: "Location", width: 50, alignment: "flex-start" },
    {
      id: "linkedinUrl",
      label: "LinkedIn",
      width: 50,
      alignment: "flex-start",
    },
  ];

  const [searchContactLoading, setSearchContactLoading] = useState(false);

  const handleOnPageChange = async (page) => {
    setSearchContactLoading(true);
    setCurrentPage(page);

    const searchObj = {
      ...searchHist,
      page: page,
      per_page: itemsPerPage,
    };
    await handleSearchForContacts(searchObj);
    setSearchContactLoading(false);
  };

  const handleOnRowsPerPageChange = async (rowsPerPg) => {
    setSearchContactLoading(true);
    setItemsPerPage(rowsPerPg);
    const searchObj = {
      ...searchHist,
      page: currentPage,
      per_page: rowsPerPg,
    };
    await handleSearchForContacts(searchObj);
    setSearchContactLoading(false);
  };

  const handleFindContacts = async (dataObj) => {
    setSearchContactLoading(true);
    setCurrentPage(1);

    const searchObj = {
      ...dataObj,
      page: 1,
      per_page: itemsPerPage,
    };
    await handleSearchForContacts(searchObj);
    setSearchContactLoading(false);
  };

  useEffect(() => {
    if (!searchedContacts) return;

    let filtered = searchedContacts;

    // filtered = dynamicSmartSort(filtered,sortKeyMap?.[sortState?.sortKey]?sortKeyMap[sortState.sortKey]:sortState.sortKey,sortState.sortConfig);
    // console.log("paginated",filtered?.splice(currentPage-1,itemsPerPage))
    const enhanced = filtered.map((item) => {
      const isExisting = spotContactsDataIDS?.includes(item?.id);

      return {
        ...item,
        id: item?.id,
        contactName: (
          <>
            {item?.name}{" "}
            <span
              style={{ marginLeft: "1vh" }}
              className={`scrc-badge ${isExisting ? "" : "new"}`}
            >
              {isExisting ? null : "New"}
            </span>
          </>
        ),
        linkedinUrl: item?.linkedin_url ? (
          <a
            href={item.linkedin_url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="scrc-linkedin"
            title="View on LinkedIn"
            onClick={(e) => {
              e.preventDefault(); // prevent default <a> if invalid
              if (item.linkedin_url) {
                const url = item.linkedin_url.startsWith("http")
                  ? item.linkedin_url
                  : `https://${item.linkedin_url}`;
                window.open(url, "_blank", "noopener,noreferrer");
              }
            }}
          >
            <i className="fa fa-linkedin-square" aria-hidden="true"></i>
          </a>
        ) : (
          "-"
        ),
      };
    });

    setTabData(enhanced);
  }, [searchedContacts, currentPage, itemsPerPage]);

  const toggleSelectAll = () => {
    if (selectedContacts.length === searchedContacts?.length) {
      setSelectedContacts([]); // Deselect all
    } else {
      setSelectedContacts((prev)=>[...prev,...searchedContacts]); // Select all (entire row objects)
    }
  };

  // this is for the selection from find contacts
  const isAllSelected =
    searchedContacts.length > 0 &&
    selectedContacts.length === searchedContacts.length;

  const isIndeterminate =
    selectedContacts.length > 0 &&
    selectedContacts.length < searchedContacts.length;

  return (
    <div className="scrc-card">
      {/* Tabs */}
      <div className="scrc-tab-header">
        {/* NEW: ADD tab */}
        {/* <button
          className={`scrc-tab-btn ${activeTab === "ADD" ? "is-active" : ""}`}
          onClick={() => setActiveTab("ADD")}
        >
          Add Contacts
        </button> */}
        {!skipSearch && (
          <button
            className={`scrc-tab-btn ${
              activeTab === "FIND" ? "is-active" : ""
            }`}
            onClick={() => setActiveTab("FIND")}
          >
            Find Contacts
          </button>
        )}

        <button
          className={`scrc-tab-btn ${
            activeTab === "SELECTED" ? "is-active" : ""
          }`}
          onClick={() => setActiveTab("SELECTED")}
        >
          Selected Contacts{" "}
          {selectedContacts.length > 0 && `(${selectedContacts.length})`}
        </button>
      </div>

      {activeTab === "FIND" && (
        <div className="find-opportunities-results-container">
          <NurtureCampaignContactSearch
            initialTitle={searchHist?.titles}
            initialSeniority={searchHist?.person_seniorities}
            initialLocation={searchHist?.person_locations}
            locationMode="multiple"
            onSearch={handleFindContacts}
          />

          {searchedContacts?.length ? (
            <GenericTable 
            
              disableSort={true}
              toggleSelectAll={toggleSelectAll}
              setSelectedRows={setSelectedContacts}
              selectedRows={selectedContacts}
              allowSelection={true}
              isAllSelected={isAllSelected}
              isIndeterminate={isIndeterminate}
              enablePagination={true}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              // onPageChange={handleOnPageChange}
              totalItems={totalEntires}
              initialColumns={tableColumns}
              tabData={tabData}
              // sideCardTabConfig={showContactSc ? tabConfigForContact : tabConfig}
              // showMoreModal={false}
              onPageChange={handleOnPageChange}
              onRowsPerPageChange={handleOnRowsPerPageChange}
              loading={searchContactLoading}
              oppName={null}
            />
          ) : (
            <NoDataComp message="Please Search Contacts" />
          )}
        </div>
      )}

      {activeTab === "ADD" && (
        <AddOrUploadContactForm
          setActiveTab={setActiveTab}
          onAdd={handleAddContact}
          existing={selectedContacts}
          setSelectUploadedContacts={setSelectUploadedContacts}
          selectUploadedContacts={selectUploadedContacts}
          manuallyAddedContacts={manuallyAddedContacts}
          setManuallyAddedContacts={setManuallyAddedContacts}
        />
      )}

      {activeTab === "SELECTED" && (
        <SelectedContactTable
          selectedContacts={selectedContacts}
          setSelectedContacts={setSelectedContacts}
          onClose={() => setActiveTab("FIND")}
          setManuallyAddedContacts={setManuallyAddedContacts}
          user={user}
          account={account}
          disableForward={disableForward}
          setDisableForward={setDisableForward}
          campaignId={campaignId}
        />
      )}
    </div>
  );
}
